import {Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import {IDsDropdownOption} from "../ds-dropdown/ds-dropdown-option";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-multiselect',
    templateUrl: './ds-multiselect.component.html',
    styleUrls: ['./ds-multiselect.component.scss'],
    standalone: false
})
export class DsMultiselectComponent implements OnInit {
  @Input() public dsDropdownOptions: IDsDropdownOption[];
  @Input() public dsDropdownDisabled?: boolean = false;
  @Input() public dsDropdownWidth?: string = '100%';
  @Input() public dsDropdownHeight?: string = '40px';
  @Input() public dsDropDownTitle?: string = 'Select Options';
  @Input() public dsSelectedOptions: Array<string> = [];
  @Output() public dsChosenOptions = new EventEmitter<{options: IDsDropdownOption[]}>();
  public showDropDown: boolean = false;
  public selectedOptions: IDsDropdownOption[] = [];
  private readonly _click: Function;

  constructor(
    private renderer2: Renderer2,
    private $element: ElementRef,
  ) {
    this._click = this.renderer2.listen(document, "click", event => {
      if (!this.$element.nativeElement.contains(event.target) ) {
        this.showDropDown = false;
      }
    });
  }


  ngOnInit() {
    this.dsSelectedOptions.forEach((item) => {
      let selectedItem = this.dsDropdownOptions.find(e => e.value === item);
      this.selectedOptions.push(selectedItem);
    });
  }

  public toggleSelection(option) {
    const index = this.selectedOptions.findIndex(item => item.value === option.value);
    if (index > -1) {
      this.selectedOptions.splice(index, 1);
    } else {
      this.selectedOptions.push(option);
    }
    this.dsChosenOptions.emit({options: this.selectedOptions});
  }
}
